import styled from 'styled-components';
import { FaShoppingCart } from 'react-icons/fa';
import { white, blue } from 'theme/colors';

export const CartIcon = styled(FaShoppingCart)`
	font-size: 2rem;
	position: relative;
	opacity: ${({ opacity }) => opacity};
	margin-right: 2rem;
`;

export const Items = styled.span`
	background-color: ${blue};
	color: ${white};
	padding: 0rem;
	position: absolute;
	border-radius: 9999px;
	font-size: 1rem;
	top: 0rem;
	right: -0.8rem;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 2rem;
	width: 2rem;
`;
